export default {
  'monitor.online.query.nickname.label': 'User nickname',
  'monitor.online.query.nickname.placeholder': 'Enter user nickname',
  'monitor.online.query.search': 'Search',
  'monitor.online.query.reset': 'Reset',
  'monitor.online.column.username': 'Login name',
  'monitor.online.column.nickname': 'User nickname',
  'monitor.online.column.deptName': 'Department',
  'monitor.online.column.loginIp': 'Login IP',
  'monitor.online.column.loginRegion': 'Login location',
  'monitor.online.column.loginTime': 'Login time',
  'monitor.online.column.browser': 'Browser',
  'monitor.online.column.os': 'Operating system',
  'monitor.online.column.operation': 'Operation',
  'monitor.online.column.operation.logout': 'Force logout',
  'monitor.online.column.operation.kickout': 'Kick out',
  'monitor.online.logout.confirm': 'Are you sure to force logout "{username}"?',
  'monitor.online.logout.title': 'Prompt',
  'monitor.online.logout.confirmButtonText': 'Confirm',
  'monitor.online.logout.cancelButtonText': 'Cancel',
  'monitor.online.logout.success': 'Force logout success',
  'monitor.online.kickout.confirm': 'Are you sure to kick "{username}" offline?',
  'monitor.online.kickout.title': 'Prompt',
  'monitor.online.kickout.confirmButtonText': 'Confirm',
  'monitor.online.kickout.cancelButtonText': 'Cancel',
  'monitor.online.kickout.success': 'Kick out success'
}
